var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4998 18.1503C34.4998 27.542 26.8886 35.1553 17.4999 35.1553C8.11126 35.1553 0.5 27.542 0.5 18.1503C0.5 8.75852 8.11126 1.14526 17.4999 1.14526C26.8886 1.14526 34.4998 8.75852 34.4998 18.1503Z",
    stroke: "#D6D6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3892 9.17401C23.0957 9.17401 24.6485 10.5524 24.6485 12.9537V24.887C24.6485 25.3877 24.3979 25.8384 23.9766 26.0905C23.5569 26.3433 23.051 26.3483 22.6265 26.102L17.871 23.3378L13.0715 26.1077C12.864 26.2276 12.6366 26.2883 12.4084 26.2883C12.173 26.2883 11.9376 26.2235 11.7238 26.0938C11.3033 25.8417 11.0527 25.391 11.0527 24.8911V12.8034C11.0527 10.4966 12.6063 9.17401 15.3152 9.17401H20.3892ZM20.3892 10.4054H15.3152C13.2813 10.4054 12.2496 11.2116 12.2496 12.8034V24.8911C12.2496 24.9682 12.2927 25.0101 12.3286 25.0315C12.3645 25.0544 12.4212 25.0709 12.4866 25.0331L17.5789 22.0941C17.7608 21.9898 17.9835 21.989 18.1662 22.0949L23.2146 25.029C23.2808 25.0684 23.3375 25.0503 23.3734 25.0282C23.4093 25.006 23.4516 24.9641 23.4516 24.887L23.4513 12.8601C23.4453 12.1535 23.3124 10.4054 20.3892 10.4054ZM20.7393 14.6978C21.0696 14.6978 21.3377 14.9736 21.3377 15.3135C21.3377 15.6533 21.0696 15.9292 20.7393 15.9292H14.9001C14.5698 15.9292 14.3017 15.6533 14.3017 15.3135C14.3017 14.9736 14.5698 14.6978 14.9001 14.6978H20.7393Z",
    fill: "#CBCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.21d750a09d8d707123558d63d88c4862.svg";
export { ForwardRef as ReactComponent };